import { Component } from '@angular/core';

@Component({
    selector: 'stby-modal-content',
    templateUrl: './modal-content.html',
})
export class ModalContent {}
